export const copy = {
  pt: {
    nav: { manifesto: "Manifesto", services: "Serviços", contact: "Contacto", cta: "Liberte-se" },
    hero: {
      kicker: "Consultoria Open Source — Portugal",
      lines: [
        [{ text: "A modernização" }],
        [{ text: "digital não tem" }],
        [{ text: "que ser uma " }, { text: "caixa", italic: true }],
        [{ text: "fechada.", italic: true }],
      ],
      subtitle: "Soluções open source para PMEs portuguesas. Escaláveis, transparentes e sem licenças abusivas.",
      ctaPrimary: "Explorar Serviços",
      ctaSecondary: "Falar Connosco",
      scrollHint: "deslize para explorar",
      imageCaption: "fig. 01 — infraestrutura aberta",
      brandNote: "// a nossa marca",
    },
    marquee: "CÓDIGO ABERTO • FUTURO LIVRE • SOFTWARE LIVRE • TECNOLOGIA SEM LIMITES • IA LOCAL • DADOS SOBERANOS • ",
    manifesto: {
      kicker: "O Manifesto Aberto",
      title: "Princípios que não compilamos em segredo.",
      chapters: [
        {
          number: "01",
          title: "Filosofia",
          text: "Acreditamos que a tecnologia deve libertar, não prender. O open source devolve o controlo às empresas — o código é seu, os dados são seus, o futuro é seu.",
        },
        {
          number: "02",
          title: "Transparência",
          text: "Sem caixas negras. Código aberto significa segurança auditável, independência de fornecedores e crescimento sustentável sem licenças que escalam contra si.",
        },
        {
          number: "03",
          title: "Portugal Digital",
          text: "Elevamos as PMEs portuguesas ao padrão global com infraestruturas modernas e IA open source — sem comprometer a privacidade nem a soberania dos dados.",
        },
      ],
      imageCaption: "fig. 02 — sem caixas negras",
    },
    services: {
      kicker: "Serviços",
      title: "A Nossa Stack",
      subtitle: "Quatro pilares. Zero dependências bloqueantes. Tudo assistido por IA open source.",
      items: [
        {
          index: "01",
          title: "Open Cloud & Infraestrutura",
          desc: "Implementação de servidores robustos, Nextcloud e gestão de dados proprietária. A sua nuvem, nas suas mãos.",
          tags: ["Nextcloud", "Kubernetes", "Proxmox"],
        },
        {
          index: "02",
          title: "Sistemas de Pagamentos",
          desc: "Gateways abertas e integrações seguras, sem taxas ocultas nem dependências bloqueantes.",
          tags: ["Gateways Abertas", "APIs", "Conformidade"],
        },
        {
          index: "03",
          title: "Email, Sites & CRM",
          desc: "Gestão completa do ciclo de vida digital com ferramentas open source de alta performance.",
          tags: ["Email Soberano", "Sites", "Twenty CRM"],
        },
        {
          index: "04",
          title: "IA Open Source",
          desc: "Modelos locais, automação inteligente e privacidade total dos dados empresariais.",
          tags: ["LLMs Locais", "Ollama", "Automação"],
        },
      ],
    },
    contact: {
      kicker: "Contacto",
      title: "Vamos libertar o seu negócio.",
      subtitle: "Conte-nos onde está e onde quer chegar. Respondemos em 24 horas úteis.",
      name: "Nome",
      email: "Email",
      company: "Empresa",
      service: "Serviço de Interesse",
      servicePlaceholder: "Selecione um serviço",
      serviceOptions: [
        "Open Cloud & Infraestrutura",
        "Sistemas de Pagamentos",
        "Email, Sites & CRM",
        "IA Open Source",
        "Outro",
      ],
      message: "Mensagem",
      messagePlaceholder: "Descreva o desafio da sua empresa…",
      consent: "Autorizo o tratamento dos meus dados pela Libertec para resposta e proposta comercial, nos termos do RGPD.",
      submit: "Enviar Pedido",
      sending: "A enviar…",
      success: "Pedido enviado. O primeiro passo para se libertar está dado.",
      error: "Algo falhou. Tente novamente.",
      emailLabel: "email",
      locationLabel: "base",
      location: "Lisboa, Portugal",
    },
    chat: {
      title: "assistente — libertec",
      status: "online",
      greeting: "Olá! Como posso ajudar a libertar a sua empresa hoje?",
      placeholder: "Escreva a sua mensagem…",
      thinking: "a processar",
      error: "De momento não consigo responder. Use o formulário de contacto, por favor.",
    },
    footer: {
      tagline: "Feito com código aberto em Portugal.",
      rights: "© 2026 Libertec. Todos os direitos livres.",
      admin: "Backoffice",
    },
    privacy: {
      text: "Este site regista apenas estatísticas de visita anónimas — sem cookies, sem dados pessoais, sem caixas negras.",
      accept: "Compreendi",
    },
  },
  en: {
    nav: { manifesto: "Manifesto", services: "Services", contact: "Contact", cta: "Break Free" },
    hero: {
      kicker: "Open Source Consultancy — Portugal",
      lines: [
        [{ text: "Digital" }],
        [{ text: "modernization doesn't" }],
        [{ text: "have to be a " }, { text: "closed", italic: true }],
        [{ text: "box.", italic: true }],
      ],
      subtitle: "Open source solutions for Portuguese SMEs. Scalable, transparent, and without abusive licenses.",
      ctaPrimary: "Explore Services",
      ctaSecondary: "Talk to Us",
      scrollHint: "scroll to explore",
      imageCaption: "fig. 01 — open infrastructure",
      brandNote: "// our mark",
    },
    marquee: "OPEN SOURCE • FREE FUTURE • FREE SOFTWARE • LIMITLESS TECHNOLOGY • LOCAL AI • SOVEREIGN DATA • ",
    manifesto: {
      kicker: "The Open Manifesto",
      title: "Principles we don't compile in secret.",
      chapters: [
        {
          number: "01",
          title: "Philosophy",
          text: "We believe technology should liberate, not trap. Open source gives control back to businesses — the code is yours, the data is yours, the future is yours.",
        },
        {
          number: "02",
          title: "Transparency",
          text: "No black boxes. Open source means auditable security, vendor independence, and sustainable growth without licenses that scale against you.",
        },
        {
          number: "03",
          title: "Digital Portugal",
          text: "We elevate Portuguese SMEs to global standards with modern infrastructure and open source AI — without compromising privacy or data sovereignty.",
        },
      ],
      imageCaption: "fig. 02 — no black boxes",
    },
    services: {
      kicker: "Services",
      title: "Our Stack",
      subtitle: "Four pillars. Zero blocking dependencies. Everything assisted by open source AI.",
      items: [
        {
          index: "01",
          title: "Open Cloud & Infrastructure",
          desc: "Robust server implementation, Nextcloud, and proprietary data management. Your cloud, in your hands.",
          tags: ["Nextcloud", "Kubernetes", "Proxmox"],
        },
        {
          index: "02",
          title: "Payment Systems",
          desc: "Open gateways and secure integrations with no hidden fees or blocking dependencies.",
          tags: ["Open Gateways", "APIs", "Compliance"],
        },
        {
          index: "03",
          title: "Email, Sites & CRM",
          desc: "Complete digital lifecycle management with high-performance open source tools.",
          tags: ["Sovereign Email", "Websites", "Twenty CRM"],
        },
        {
          index: "04",
          title: "Open Source AI",
          desc: "Local models, intelligent automation, and total privacy for corporate data.",
          tags: ["Local LLMs", "Ollama", "Automation"],
        },
      ],
    },
    contact: {
      kicker: "Contact",
      title: "Let's set your business free.",
      subtitle: "Tell us where you are and where you want to go. We reply within 24 business hours.",
      name: "Name",
      email: "Email",
      company: "Company",
      service: "Service of Interest",
      servicePlaceholder: "Select a service",
      serviceOptions: [
        "Open Cloud & Infrastructure",
        "Payment Systems",
        "Email, Sites & CRM",
        "Open Source AI",
        "Other",
      ],
      message: "Message",
      messagePlaceholder: "Describe your company's challenge…",
      consent: "I authorize Libertec to process my data to respond and prepare a commercial proposal, under GDPR.",
      submit: "Send Request",
      sending: "Sending…",
      success: "Request sent. Your first step to freedom is taken.",
      error: "Something failed. Please try again.",
      emailLabel: "email",
      locationLabel: "base",
      location: "Lisbon, Portugal",
    },
    chat: {
      title: "assistant — libertec",
      status: "online",
      greeting: "Hello! How can I help set your company free today?",
      placeholder: "Type your message…",
      thinking: "processing",
      error: "I can't respond right now. Please use the contact form.",
    },
    footer: {
      tagline: "Built with open source in Portugal.",
      rights: "© 2026 Libertec. All rights free.",
      admin: "Backoffice",
    },
    privacy: {
      text: "This site records only anonymous visit statistics — no cookies, no personal data, no black boxes.",
      accept: "Got it",
    },
  },
};
